import qs from 'querystring';
const getKbbTradeIns = async _ref => {
  let {
    blockTradeInFetch,
    cbhTradeIns,
    tradeInFetcher,
    pixAllId,
    debug
  } = _ref;
  // try to use pre-fetched tradeIns on the atc & kbb srps to reduce cbh calls
  let tradeIns = cbhTradeIns;
  if (!blockTradeInFetch && !tradeIns?.length && tradeInFetcher && pixAllId && pixAllId !== 'nl') {
    const response = await tradeInFetcher.fetch(pixAllId, debug);
    tradeIns = response?.kbbTradeIns || [];
  }
  const values = [];
  if (tradeIns.length > 0) {
    tradeIns.forEach(tradeIn => {
      const {
        eventTimestamp,
        make,
        model,
        price: value,
        url,
        year,
        searchZipCode
      } = tradeIn;
      if (value) {
        const date = new Date(eventTimestamp);
        let trimString = null;
        let searchParams = url;
        try {
          const {
            pathname,
            search
          } = new URL(url);
          if (search) {
            searchParams = search.replace('?', '');
          }
          if (pathname) {
            // eslint-disable-next-line prefer-destructuring
            trimString = pathname.split('/')[4];
            trimString = trimString && trimString.replace(/-/g, ' ').toUpperCase();
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
        const queryParams = qs.parse(searchParams);
        const {
          condition,
          mileage,
          vehicleid
        } = queryParams;
        values.push({
          value,
          condition,
          year,
          make,
          model,
          trim: trimString,
          mileage,
          valuationDate: date.toISOString(),
          vehicleid,
          zip: searchZipCode
        });
      }
    });
    // Keep only the latest valuation for a YMMT
    const filteredValues = values.reduce(function () {
      let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!data.some(item => item.year === current.year && item.make === current.make && item.model === current.model && item.trim === current.trim)) {
        data.push(current);
      }
      return data;
    }, []);
    // limits to the most recent 3
    return filteredValues.slice(0, 3);
  }
  return null;
};
export { getKbbTradeIns as default };
